import { Workspace } from '@weblite/ts-action/workspace'
import { createStorage } from '$logic/lib/storage'
import { RootState } from '$setup/redux'

const COLLECTION = 'workspace'

const [workspaceStorage, workspaceReducer] =
  createStorage<Workspace>(COLLECTION)

export { workspaceStorage, workspaceReducer }

export const getWorkspacesView = (
  state: RootState,
): Record<string, Workspace> => state.main?.workspace

export const getWorkspaceByIdView =
  (id: string) =>
  (state: RootState): Workspace | undefined =>
    state.main?.workspace?.[id]
